import { useHistory, useLocation } from "react-router-dom";
import cx from "classnames";
import { motion } from "framer-motion";
import { Button } from "@mui/material";

import style from "./DemoModal.module.scss";
import { hideModal, MODAL_CLOSE_TYPE } from "../../storage/emitter";
import { useCallback } from "react";
import { WhiteButton } from '../Buttons'
import { fade } from '../../storage/motionAnimations'

const contentStyle = {
  hidden: {
    opacity: 0,
    transform: "scale(0.5)",
  },
  visible: {
    opacity: 1,
    transform: "scale(1)",
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    opacity: 0,
    transform: "scale(0.5)",
  },
};

export default function DemoModal({ closeType }) {
  const { pathname } = useLocation();
  const history = useHistory();

  const onClose = useCallback(
    (event) => {
      if (closeType === MODAL_CLOSE_TYPE.HOME) {
        history.replace("/");
      } else if (closeType === MODAL_CLOSE_TYPE.BACK) {
        history.goBack();
      }
      hideModal("demo");
    },
    [closeType]
  );

  return (
    <div className={cx("modal modal--fullscreen", style.modal)}>
      <motion.div
        className={cx("modal-underlay", style.underlay)}
        variants={fade}
        initial="hidden"
        animate="visible"
        exit="exit"
      />
      <motion.div
        onClick={(e) => e.stopPropagation()}
        variants={contentStyle}
        initial="hidden"
        animate="visible"
        exit="exit"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div className={cx("modal-content", style.content)}>
          <h1>We are sorry</h1>
          <p>
            This feature is not available on this demo. Please press back to go
            to the previous screen.
          </p>
          <WhiteButton onClick={onClose} variant="contained" className="button button--big">
            Back
          </WhiteButton>
        </div>
      </motion.div>
    </div>
  );
}
